import { createContext, useContext, useState, useEffect } from 'react';
import { api, endpoints } from '../config/api';
import { DEFAULT_DESIGN_CONFIG } from '../config/assets';

const ConfigContext = createContext({
  config: null,
  loading: true,
  error: null,
});

function mergeWithDefaults(apiConfig) {
  const defaults = { ...DEFAULT_DESIGN_CONFIG };
  if (!apiConfig) return defaults;
  return {
    ...defaults,
    ...apiConfig,
    bodyBackgroundImage: apiConfig.bodyBackgroundImage || defaults.bodyBackgroundImage,
    headerImage: apiConfig.headerImage || defaults.headerImage,
    logoUrl: apiConfig.logoUrl || defaults.logoUrl,
    additionalLogos: (apiConfig.additionalLogos?.length > 0 ? apiConfig.additionalLogos : defaults.additionalLogos) || [],
    mujerKvUrl: apiConfig.mujerKvUrl || defaults.mujerKvUrl,
    welcomeLogos: apiConfig.welcomeLogos || defaults.welcomeLogos,
  };
}

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    api
      .get(endpoints.configurationsActive())
      .then((data) => {
        setConfig(mergeWithDefaults(data));
        setError(null);
      })
      .catch((err) => {
        setError(err?.message);
        setConfig(mergeWithDefaults(null));
      })
      .finally(() => setLoading(false));
  }, []);

  const value = { config, loading, error };
  return (
    <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>
  );
}

export function useConfig() {
  const ctx = useContext(ConfigContext);
  if (!ctx) {
    throw new Error('useConfig debe usarse dentro de ConfigProvider');
  }
  return ctx;
}

/**
 * Genera variables CSS desde la configuración
 */
export function configToCssVars(config) {
  if (!config) return {};
  return {
    '--config-font-color': config.fontColor || '#1f2937',
    '--config-font-color-secondary': config.fontColorSecondary || '#6b7280',
    '--config-font-family': config.fontFamily || 'inherit',
    '--config-body-bg': config.bodyBackground || '#f9fafb',
    '--config-primary-color': config.primaryColor || '#2563eb',
    '--config-secondary-color': config.secondaryColor || '#64748b',
    '--config-button-color': config.buttonColor || '#2563eb',
    '--config-button-text-color': config.buttonTextColor || '#ffffff',
  };
}
